// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._idu5IifFNxAkRuL2F_d {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 60;
}

.rXRDS3Bs2OTgh4xJIkuQ {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 0;
  border-left: 1.5px dashed #ef4444;
  will-change: transform;
}

.onzWpSMKPB9kDHn7kvsI {
  position: absolute;
  top: 6px;
  left: 0;
  margin-left: 8px;
  padding: 2px 6px;
  border-radius: 3px;
  background: #ef4444;
  color: #fff;
  font-size: 10px;
  line-height: 1.4;
  white-space: nowrap;
  will-change: transform;
}
`, "",{"version":3,"sources":["webpack://./src/widget/components/replay/ReplayCutOverlay.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB","sourcesContent":[".cutLayer {\r\n  position: absolute;\r\n  inset: 0;\r\n  overflow: hidden;\r\n  pointer-events: none;\r\n  z-index: 60;\r\n}\r\n\r\n.cutLine {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 0;\r\n  border-left: 1.5px dashed #ef4444;\r\n  will-change: transform;\r\n}\r\n\r\n.cutBadge {\r\n  position: absolute;\r\n  top: 6px;\r\n  left: 0;\r\n  margin-left: 8px;\r\n  padding: 2px 6px;\r\n  border-radius: 3px;\r\n  background: #ef4444;\r\n  color: #fff;\r\n  font-size: 10px;\r\n  line-height: 1.4;\r\n  white-space: nowrap;\r\n  will-change: transform;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cutLayer": `_idu5IifFNxAkRuL2F_d`,
	"cutLine": `rXRDS3Bs2OTgh4xJIkuQ`,
	"cutBadge": `onzWpSMKPB9kDHn7kvsI`
};
export default ___CSS_LOADER_EXPORT___;
